import { useEffect, useState } from "react";
import { InterviewService } from "../../../services/InterviewService";
import { useInterviewContext } from "../InterviewContext";
import TechnicalSkillsSectionItem from "./TechnicalSkillsSectionItem";
import { useTranslation } from "react-i18next";
import { DropDownMultiCheck } from "../AdvanceSearch/DropDownMultiCheck";
import { CommonService } from "../../../services/CommonService";
import { JobRoleDetailService } from "../../../services/JobRoleDetailService";

const TechnicalSkillsSection = ({
  selectedTechnologies,
  selectSingleTechnology,
  selectMltipleTechnology
}) => {
  const [technologiesFields, setTechnologiesFields] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [maintechnologies, setMainTechnologies] = useState([]);
  const { interview, setInterview, errors } = useInterviewContext();
  const { t } = useTranslation();

  useEffect(() => {
    InterviewService.getAllTechnologies().then((data) =>
      setTechnologiesFields(data)
    );
    CommonService.getTechSkills().then((data) => setTechnologies(data));
  }, []);

  useEffect(() => {
    if (interview.personalInformation?.techRoleId) {
      JobRoleDetailService.getTechSkillsByRole(
        interview.personalInformation?.techRoleId
      ).then((data) => {
        let _maintechnologies = [data];
        setMainTechnologies(_maintechnologies);
      });
    }
  }, [interview.personalInformation?.techRoleId]);

  return (
    <div className="technical-skills">
      <div>
        <DropDownMultiCheck
          dataList={technologies}
          selecteds={technologies.filter((x) => {
            return selectedTechnologies?.map((s) => s.id).indexOf(x.id) > -1;
          })}
          setSelecteds={selectMltipleTechnology}
        />
      </div>

      {errors.technologies && (
        <div className="error-msg">{errors.technologies}</div>
      )}
      <div className="accordion accordion-flush" id="accordion">
        {technologiesFields.map((technologyField, index) => (
          <TechnicalSkillsSectionItem
            index={index}
            heading={t(technologyField.description)}
            technologiesSubFields={technologyField.technologiesSubFields}
            onChange={(tech) =>
              selectSingleTechnology(tech, selectedTechnologies)
            }
            selectedTechnologies={selectedTechnologies}
          />
        ))}
      </div>
    </div>
  );
};

export default TechnicalSkillsSection;
